import React from 'react';
import { LeaderboardEntry } from '../types';

interface MetricSelectorProps {
  currentMetric: string;
  onMetricChange: (metric: string) => void;
}

const MetricSelector: React.FC<MetricSelectorProps> = ({ 
  currentMetric, 
  onMetricChange
}) => {
  // Define the static metrics with new fields
  const staticMetrics: Array<{
    key: keyof Omit<LeaderboardEntry, 'userId' | 'email'>;
    label: string;
  }> = [
    { key: 'spendPerUser', label: 'Spend (Cycle to Date)' },
    { key: 'chatTotalApplies', label: 'Chat Total Applies' },
    { key: 'chatTotalAccepts', label: 'Chat Total Accepts' },
    { key: 'chatAcceptedLinesAdded', label: 'Chat Accepted Lines Added' },
    { key: 'totalLinesAdded', label: 'Total Lines Added' },
    { key: 'chatTabsShown', label: 'Chat Tabs Shown' },
    { key: 'tabsAccepted', label: 'Tabs Accepted' },
    { key: 'editRequests', label: 'Edit Requests' },
    { key: 'askRequests', label: 'Ask Requests' },
    { key: 'agentRequests', label: 'Agent Requests' },
    { key: 'cmdkRequests', label: 'Cmd+K Requests' },
  ];

  // Ensure current metric is available, fallback to first available if not
  const validCurrentMetric = staticMetrics.find(m => m.key === currentMetric) 
    ? currentMetric 
    : staticMetrics[0]?.key || '';

  return (
    <div className="metric-selector">
      <label htmlFor="metric-select">Sort by:</label>
      <select
        id="metric-select"
        value={validCurrentMetric}
        onChange={(e) => onMetricChange(e.target.value)}
      >
        {staticMetrics.map((metric) => (
          <option key={metric.key} value={metric.key}>
            {metric.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MetricSelector; 